import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-delete-group-dialog',
  templateUrl: './menu-delete-group-dialog.component.html',
  styleUrls: ['./menu-delete-group-dialog.component.css']
})
export class MenuDeleteGroupDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
